class TableLoadMore {
  table
  rows
  loadMoreButton
  ariaLive
  moveIntoAriaLive
  constructor(attr) {
    this.table = attr.document.querySelector('.js-table-load-more')
    if (!this.table) return
    this.rows = this.table.querySelectorAll('tbody tr')
    this.loadMoreButton = attr.document.querySelector(
      '.js-table-load-more-trigger',
    )
    this.ariaLive = attr.document.querySelector('.js-aria-live')
    this.moveIntoAriaLive = attr.document.querySelector(
      '.js-move-into-aria-live',
    )

    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', (event) =>
        this.handleLoadMoreClick(event),
      )
    }
  }

  showAllRows() {
    this.table.classList.remove('table-hide')
  }

  handleLoadMoreClick(event) {
    event.preventDefault()

    this.showAllRows()
    this.loadMoreButton.style.display = 'none'
    if (this.moveIntoAriaLive && this.ariaLive) {
      this.ariaLive.innerHTML += ' ' + this.moveIntoAriaLive.innerHTML
    }
  }

  static build(attr) {
    return new TableLoadMore(attr)
  }
}

export default function () {
  TableLoadMore.build({ document })
}
